import { CART_MODULE } from "@/api_framework/api_config";
import { ICartUpdateResponse } from "@/api_framework/api_modals/Cart";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { setActiveCartId } from "@/app_redux/reducers/slices/auth/cart_slice";

AxiosCurlirize(axios, () => {});

export interface IInvoiceCancel {
  invoice_id: string;
  clinic_id: string;
  clinic_name: string;
  cancellation_reason: string;
  cancellation_option: string;
}
export const useInvoiceCancelAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError, toastNotification } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (invoicePayload: IInvoiceCancel) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: any = await axios
          .put(`${CART_MODULE?.INVOICE_CANCEL?.baseURL}`, invoicePayload, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ICartUpdateResponse>) => {
            if (res.data.status === true) {
              toastNotification(res.data.message);
              dispatch(setActiveCartId(res.data.data?.cart_id));
              return { status: true, cartId: res.data.data?.cart_id };
            } else {
              return { status: false, cartId: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);

            return { status: false, cartId: null };
          });
        return response;
      } catch (e) {
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
